import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { common } from '@/styles/styles';

import { Text } from './TextComponent';
import { ds } from './lib/design.system';

const styles = StyleSheet.create({
    root: {
        height: 56,
        borderBottomWidth: 1,
        borderBottomColor: ds.colorValue.border.strong,
    },
});

type Props = {
    label: string;
    secondaryLabel?: string | React.ReactNode;
    buttonLabel: string;
    handlePress: () => void;
    testID?: string;
};

export const ActionItem = ({ label, secondaryLabel, buttonLabel, handlePress, testID }: Props) => {
    return (
        <View style={[styles.root, common.spaceBetweenRow]}>
            <View>
                <Text variant="bodyMedium">{label}</Text>
                {secondaryLabel ? (
                    <Text color={ds.colorToken.text.secondary} variant="bodySmall" testID="currentLimitAmount">
                        {typeof secondaryLabel === 'string' ? secondaryLabel : <>{secondaryLabel}</>}
                    </Text>
                ) : null}
            </View>
            <TouchableOpacity onPress={handlePress} testID={testID}>
                <Text fontWeight={'bold'} textDecorationLine={'underline'} fontSize={15}>
                    {buttonLabel}
                </Text>
            </TouchableOpacity>
        </View>
    );
};
